import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle
} from '@ionic/react';

import styles from './EmailSentCard.module.scss';

import { State } from '../../constants/state';
import { Service } from '../../services/service';
import { GitLiveLogo } from '../GitLiveLogo/GitLiveLogo';
import { ServiceLoader } from '../ServiceLoader/ServiceLoader';

export interface EmailSentCardProps {
  email: string;
  service?: Service;
}

export const EmailSentCard = ({ service, email }: EmailSentCardProps) => (
  <div className={styles.cardContainer}>
    {service ? (
      <ServiceLoader service={service.id} state={State.Successful} />
    ) : (
      <GitLiveLogo />
    )}
    <IonCard className={styles.card}>
      <IonCardHeader>
        <IonCardTitle className={styles.title}>
          Your sign in link has be sent to {email}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <p>
          Please check your inbox for an email from GitLive and click the link
          to complete the sign in process.
        </p>
      </IonCardContent>
    </IonCard>
  </div>
);
